module.exports = __webpack_public_path__ + "static/media/video-thumb-1.08227f30.jpg";